import React from 'react';
import { Spin, Empty, Result, Button } from 'antd';

/** Centered spinner for in-flight loads. */
export const LoadingState = ({ tip = 'Loading...' }) => (
  <div className="state-block">
    <Spin size="large" tip={tip}>
      <div style={{ padding: 24 }} />
    </Spin>
  </div>
);

/** Empty list / no-records placeholder. */
export const EmptyState = ({ description = 'No records yet.', children }) => (
  <div className="state-block">
    <Empty description={description}>{children}</Empty>
  </div>
);

/**
 * Server / request error. Per handoff section 19, a failed request must NOT be
 * shown as an empty list - use this so the failure is explicit and retryable.
 */
export const ErrorState = ({
  title = 'Something went wrong',
  message = 'Please try again.',
  onRetry,
}) => (
  <Result
    status="error"
    title={title}
    subTitle={message}
    extra={onRetry ? <Button type="primary" onClick={onRetry}>Retry</Button> : null}
  />
);

/** 403 screen - keep the session, just deny the view. */
export const AccessDenied = () => (
  <Result
    status="403"
    title="Access Denied"
    subTitle="Your role does not have permission to view this page."
  />
);

/**
 * Shared error renderer for data screens. Per handoff section 19, a 403 from the
 * API must show Access Denied (not a retryable "server error"); everything else
 * shows the retryable ErrorState.
 */
export const ApiErrorState = ({ error, onRetry }) => {
  if (error?.status === 403) return <AccessDenied />;
  return <ErrorState message={error?.message} onRetry={onRetry} />;
};
